var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header_roe"},[_c('div',{staticClass:"header_brand"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{}}},[_vm._v(_vm._s(_vm.$t(_vm.$route.meta.module)))]),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$t(_vm.$route.meta.title)))])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }